import { Event } from '@adminModels';
import { EventResponse } from '@klubovna/api-client';

export function toAdminEvent(response: EventResponse): Event {
  return {
    id: response.id,
    slug: response.slug,
    name: response.name,
    shortName: response.shortName,
    date: response.date,
    endDate: response.endDate,
    link: response.link || '',
    buttonType: response.buttonType as any,
    buttonText: response.buttonText || '',
    buttonTextEn: response.buttonTextEn || '',
    tags: response.tags as any[],
    guests: response.guests as any[],
    entryPrice: response.entryPrice,
    private: response.private,
    titleImage: response.titleImage,
    titleText: response.titleText,
    titleTextEn: response.titleTextEn || '',
    description: response.description,
    descriptionEn: response.descriptionEn || '',
    youform: response.youform || '',
    thumbnailPicture: response.thumbnailPicture,
    status: response.status,
    isActive: response.isActive,
    createdAt: response.createdAt,
    updatedAt: response.updatedAt
  };
}
